module.exports = __webpack_public_path__ + "static/media/filling-white.3148bff0.png";